<!--<div class="form-place">-->
  <!--<mat-card>-->
    <!--<mat-card-content>-->
      <!--<p>ProcessId: {{report.ProcessId}}</p>-->
      <!--<p>DataSourceId: {{report.DataSourceId}}</p>-->
      <!--<p>DataSourceSlug: {{report.DataSourceSlug}}</p>-->
      <!--<p>EndDateUtc: {{report.EndDateUtc}}</p>-->
      <!--<p>PercentageComplete: {{report.PercentageComplete}}</p>-->
      <!--<p>StartDateUtc: {{report.StartDateUtc}}</p>-->
      <!--<p>Status: {{report.Status}}</p>-->

      <!--<table style="overflow-x: auto">-->
        <!--<thead>-->
        <!--<tr>-->
          <!--<th>LayerId</th>-->
          <!--<th>LayerExternalId</th>-->
          <!--<th>LayerName</th>-->
          <!--<th>Status</th>-->
          <!--<th>PercentageComplete</th>-->
          <!--<th>TotalCount</th>-->
          <!--<th>IndexedCount</th>-->
          <!--<th>IndexationFailedCount</th>-->
          <!--<th>ReadAndStoredCount</th>-->
          <!--<th>FailedToReadAndStoreCount</th>-->
        <!--</tr>-->
        <!--</thead>-->
        <!--<tbody>-->
        <!--<tr *ngFor="let layer of report.Layers">-->
          <!--<td>{{layer.LayerId}}</td>-->
          <!--<td>{{layer.LayerExternalId}}</td>-->
          <!--<td>{{layer.LayerName}}</td>-->
          <!--<td>{{layer.Status}}</td>-->
          <!--<td>{{layer.PercentageComplete}}</td>-->
          <!--<td>{{layer.TotalCount}}</td>-->
          <!--<td>{{layer.IndexedCount}}</td>-->
          <!--<td>{{layer.IndexationFailedCount}}</td>-->
          <!--<td>{{layer.ReadAndStoredCount}}</td>-->
          <!--<td>{{layer.FailedToReadAndStoreCount}}</td>-->
        <!--</tr>-->
        <!--</tbody>-->
      <!--</table>-->
    <!--</mat-card-content>-->
  <!--</mat-card>-->

<!--</div>-->

<mat-card class="table-place">
  <mat-card-content class="company-details-table">
    <p>ProcessId: {{report.ProcessId}}</p>
    <p>DataSourceId: {{report.DataSourceId}}</p>
    <p>DataSourceSlug: {{report.DataSourceSlug}}</p>
    <p>EndDateUtc: {{report.EndDateUtc}}</p>
    <p>PercentageComplete: {{report.PercentageComplete}}</p>
    <p>StartDateUtc: {{report.StartDateUtc}}</p>
    <p>Status: {{report.Status}}</p>
    <button mat-button
            (click)="updateList()">
      <mat-icon>autorenew</mat-icon>
      Update
    </button>
    <button mat-button *ngIf="!isProcessFinished()" class="mat-warn"
        (click)="onProcessCancel()">
      <mat-icon>cancel</mat-icon>
      Cancel
    </button>
    <div>
      <table class="table table-condensed">
        <thead>
        <tr>
          <th>LayerId</th>
          <th>LayerExternalId</th>
          <th>LayerName</th>
          <th>Status</th>
          <th>PercentageComplete</th>
          <th>TotalCount</th>
          <th>IndexedCount</th>
          <th>IndexationFailedCount</th>
          <th>ReadAndStoredCount</th>
          <th>FailedToReadAndStoreCount</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let layer of report.Layers">
          <td>{{layer.LayerId}}</td>
          <td>{{layer.LayerExternalId}}</td>
          <td>{{layer.LayerName}}</td>
          <td>{{layer.Status}}</td>
          <td>{{layer.PercentageComplete}}</td>
          <td>{{layer.TotalCount}}</td>
          <td>{{layer.IndexedCount}}</td>
          <td>{{layer.IndexationFailedCount}}</td>
          <td>{{layer.ReadAndStoredCount}}</td>
          <td>{{layer.FailedToReadAndStoreCount}}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </mat-card-content>
</mat-card>
